import type { EmblaCarouselType } from 'embla-carousel';
import { useEffect, useState } from 'react';

export function useSelectedSnapIndex(emblaApi: EmblaCarouselType | undefined) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) {
      return;
    }

    const syncSelectedIndex = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    emblaApi.on('select', syncSelectedIndex);

    return () => {
      emblaApi.off('select', syncSelectedIndex);
    };
  }, [emblaApi]);

  return selectedIndex;
}
